import * as Sentry from '@sentry/react'
import React, { ReactNode } from 'react'
import { useTranslation } from './../../useTranslation'
import Button from './button'

export function ErrorBoundary({ children, customMessage, allowReset }: React.PropsWithChildren<{ customMessage?: ReactNode; allowReset?: boolean }>) {
    const { t } = useTranslation()

    return (
        <Sentry.ErrorBoundary
            fallback={({ resetError, error }) => {
                const potentialIssueWithBrowserPlugins = (error as any).message.includes("Failed to execute 'removeChild'")
                return (
                    <div className="w-100 h-[500px] bg-red-300 text-center flex items-center justify-center flex-col gap-8">
                        <p>{customMessage ?? t('unknownErrorHasOccured')}</p>
                        <p> {potentialIssueWithBrowserPlugins ? t('configuration.browserPluginsIssue') : null}</p>
                        <p>{allowReset && <Button onClick={resetError} text="reset" type={'squareBlue'}></Button>}</p>
                    </div>
                )
            }}
            showDialog={true}
        >
            {children}
        </Sentry.ErrorBoundary>
    )
}
